function formatHTML(text: string, i: number) {
  return (
    <p key={i} className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
      {text}
    </p>
  );
}

export default formatHTML;
